import React from 'react';

import paymentPageStyles from './paymentPage.module.css';
import { withStyles } from '@material-ui/core/styles';
import { PaymentType } from '../../models/PaymentType.enum';

interface paymentDetailsCreditProps {
  due: string;
  items: number;
  totalPay: string;
  disabled: boolean;
  totalConvenience: string;
  textConvenienceFee: string;
  fwdInvoiceBalance: number;
  applyEwallet?: boolean;
  eWalletAmount?: string;
  classes: any;
  type: string;
  paymentType: string;
};

const styles = (theme: any) => ({
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  }
});

const paymentDetailsCredit = (props: paymentDetailsCreditProps) => {
  const balance = props.applyEwallet ? Number(Number(props.fwdInvoiceBalance - ( Number(props.totalPay) - Number(props.eWalletAmount)))) : props.fwdInvoiceBalance - Number(props.totalPay) ;
  const classColor = balance > 0 ? props.classes.green : props.paymentType === PaymentType.E_WALLET_PAYMENT ? '' : props.classes.red;
  const totalCredit = props.type == 'gha' ? Number(props.fwdInvoiceBalance) - Number(props.totalConvenience) : props.fwdInvoiceBalance;
  const totalWalletBalance = props.paymentType === PaymentType.E_WALLET_PAYMENT ? Number(props.eWalletAmount) - Number(props.due) : 0;
  const walletBalance = props.eWalletAmount ? props.eWalletAmount : 0;
  return (

    <div className={[paymentPageStyles.invoiceWrapper].join(' ')}>
      <div className={[paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>

        <div className={paymentPageStyles.itemText}>{ props.paymentType === PaymentType.E_WALLET_PAYMENT ? 'eWallet' : 'Credit' } Available:</div>

        <div className={paymentPageStyles.invoicePrice}>

          <div>$</div>
          <div>{ props.paymentType === PaymentType.E_WALLET_PAYMENT ? walletBalance :  totalCredit}</div>

        </div>

      </div>
      <div className={[paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>

        <div className={paymentPageStyles.itemText}>Current amount due:</div>

        <div className={paymentPageStyles.invoicePrice}>

          <div>$</div>
          <div>{props.due}</div>

        </div>

      </div>

      {props.type !== 'gha' && <div className={[paymentPageStyles.invoiceItemsWrapper, props.disabled ? paymentPageStyles.disabledLabelColor : ''].join(' ')}>

        <div className={paymentPageStyles.itemText} >{props.textConvenienceFee}</div>

        <div className={ [paymentPageStyles.invoicePrice, props.applyEwallet ? '' : paymentPageStyles.border].join(' ') }>

          <div>$</div>
          <div>{props.totalConvenience}</div>

        </div>

      </div>}
      { props.applyEwallet && <div className={ paymentPageStyles.invoiceItemsWrapper }>

        <div className={paymentPageStyles.itemText} >e wallet balance</div>

        <div className={[paymentPageStyles.invoicePrice, paymentPageStyles.border].join(' ')}>

          <div>-$</div>
          <div>{props.eWalletAmount}</div>

        </div>

      </div>
      }

      {props.type !== 'gha' && <div className={paymentPageStyles.invoiceItemsWrapper}>

        <div className={paymentPageStyles.itemText} >New { props.paymentType === PaymentType.E_WALLET_PAYMENT ? 'eWallet' : 'Credit' } Balance</div>

        <div className={[paymentPageStyles.invoicePrice, classColor].join(" ")}>

          <div>$</div>
          <div>{ props.paymentType === PaymentType.E_WALLET_PAYMENT ? totalWalletBalance :  balance}</div>

        </div>

      </div>}

    </div>
  );
};

export default withStyles(styles)(paymentDetailsCredit);
